import { ReactElement } from "react";
import CabDatePicker, { CabDatePickerProps } from ".";
import { WeekStartDay } from "../../../store";
import { scheduling } from "../../../store/cabinetApi/scheduling";

export const UserPrefCabDatePicker = ({ 
  ...props
}: CabDatePickerProps): ReactElement => {
  const { weekStartDay, workWeekStartDay } = scheduling.useAppSchedulingPreferencesListQuery(undefined, {
    selectFromResult: ({ data }) => ({
      weekStartDay: data?.user_prefs?.week_start_day ? WeekStartDay[data.user_prefs.week_start_day] : null,
      workWeekStartDay: data?.user_prefs?.work_week_start_day ? WeekStartDay[data.user_prefs.work_week_start_day] : null
    })});

  return (
    <CabDatePicker
      {...props}
      weekStartDay={props.weekStartDay || weekStartDay}
      workWeekStartDay={props.workWeekStartDay || workWeekStartDay}
    />
  );
};

export default UserPrefCabDatePicker;